import { Provider } from './Provider.js';
import { GTMEvents } from '../types/gtm.js';

class GTMProvider extends Provider {
  track(_ref) {
    let {
      payload,
      eventName
    } = _ref;
    window.dataLayer = typeof window.dataLayer !== 'undefined' ? window.dataLayer : [];
    if (eventName === GTMEvents.EECOMMERCE) {
      window.dataLayer.push({
        ecommerce: null
      });
    }
    const parsedPayload = {
      event: eventName,
      ...this.commonPayload,
      ...payload
    };
    window.dataLayer.push(parsedPayload);
    this.logger.log(`Send GTM event with payload: ${JSON.stringify(payload)}`);
  }
  setUserId(_userId) {
    this.logger.error('GTM set user id - Method not implemented');
  }
  setUserProperties(_properties) {
    this.logger.error('GTM set user properties - Method not implemented');
  }
  scriptIsLoaded() {
    if (typeof document !== 'undefined') {
      const htmlScripts = Array.from(document.getElementsByTagName('script'));
      return !!htmlScripts.find(script => script.innerHTML.indexOf('https://www.googletagmanager.com/gtm.js?id=') > 0);
    } else {
      return false;
    }
  }
  addPageMetaData(configuration) {
    const dataLayer = {
      event: GTMEvents.PAGE_META_DATA,
      ...configuration
    };
    const scriptDL = document.createElement('script');
    scriptDL.type = 'text/javascript';
    scriptDL.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push(
                    ${JSON.stringify(dataLayer)}
                )
            `;
    document.getElementsByTagName('head')[0].appendChild(scriptDL);
    this.logger.log(`GTM dataLayer script appended to <head>`);
  }
  setConsentMode(defaultConsentBehaviours) {
    const consentModeScript = document.createElement('script');
    consentModeScript.type = 'text/javascript';
    // Second call to gtag with update to avoid error of not consent mode active in some calls
    consentModeScript.innerHTML = `
                window.dataLayer = window.dataLayer || [];

                function gtag() {
                    window.dataLayer.push(arguments);
                }

                gtag("consent", "default", ${JSON.stringify(defaultConsentBehaviours)});

                gtag("consent", "update", ${JSON.stringify(defaultConsentBehaviours)});
            `;
    document.getElementsByTagName('head')[0].appendChild(consentModeScript);
    this.logger.log(`GTM consent script appended to <head>`);
  }
  init(key, configuration) {
    if (!this.scriptIsLoaded() && typeof document !== 'undefined') {
      if (configuration) {
        const {
          defaultConsentBehaviours,
          ...pageMetaDataProps
        } = configuration;
        defaultConsentBehaviours && this.setConsentMode(defaultConsentBehaviours);
        Object.keys(pageMetaDataProps).length && this.addPageMetaData(pageMetaDataProps);
      }
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push(
                {'gtm.start': new Date().getTime(),event:'gtm.js'}
                );var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${key}');
            `;
      document.getElementsByTagName('head')[0].appendChild(script);
      this.logger.log(`GTM script appended to <head> with key: ${key}`);
      const noScript = document.createElement('noscript');
      const pixelIframe = document.createElement('iframe');
      pixelIframe.width = '0';
      pixelIframe.height = '0';
      pixelIframe.setAttribute('style', 'display: none');
      pixelIframe.src = `https://www.googletagmanager.com/ns.html?id=${key}`;
      noScript.appendChild(pixelIframe);
      document.getElementsByTagName('body')[0].appendChild(noScript);
      this.logger.log(`GTM pixel appended to <body> with key: ${key}`);
    }
  }
}

export { GTMProvider };
//# sourceMappingURL=GTMProvider.js.map
